// Explicitly uses Node export - referenced at build time
module.exports = {
  brand: '#03374E',
  background: '#FAFAFA',
  border: {
    light: '#EFEFEF',
    dark: '#D5D5D5',
    darker: '#B3B3B3',
    darkest: '#979797',
    brand: '#113043',
  },
  toast: {
    background: '#EFEFEF99',
    border: '#B3B3B3',
  },
  highlighted: '#03374E80',
  brandlight: '#224154',
  info: '#979797',
  success: '#2EA873',
  error: '#a83e2e',
  warning: '#a89a2e',
  chart: {
    baseline: '#7CB1D3',
    window: '#FFB582',
    background: {
      tooltip: '#222222AA'
    }
  },
  banner: {
    faded: {
      warning: '#fef9c2',
      error: '#ffe2e2',
      success: '#dcfce7',
      info: '#f3f4f6',
    },
    black: '#000000',
  },
  faded: {
    info: '#97979740',
    success: '#438e6e40',
    error: '#8e4d4340',
    warning: '#8e854340',
    brand: '#03374E40',
    baseline: '#7CB1D380',
    window: '#FFB58280',
  },
  link: {
    red: '#CA2D36',
    blue: '#0075FF',
  },
  text: {
    mainBlue: '#03374E'
  }
};
